import React, { useEffect, useState } from 'react';
import {
  Box, Toolbar, IconButton, Drawer, List, ListItemText, Divider, ListItemIcon, Collapse, ListItemButton,
} from '@mui/material';

import {
  Home, Logout, SchoolOutlined, PersonAddAlt, Dashboard, ExpandMore, ExpandLess, PeopleAlt, AccountCircle, Discount,
  Subscriptions, Groups, CardGiftcard, CurrencyRupee, Settings, KeyboardArrowLeft, KeyboardArrowRight, CalendarMonth,
  QrCodeScanner as QrScannerIcon, PictureAsPdf,
  Description,
  // FileCopy,
  FileUpload,
  CalendarViewDay,
  Message,
  ContactSupportSharp,
  AccountBalanceWallet,
} from '@mui/icons-material';

import { Link, useLocation, useNavigate } from 'react-router-dom';
// import AssignmentIcon from "@mui/icons-material/Assignment";
// import DescriptionIcon from "@mui/icons-material/Description";
import authService from '../Auth/AuthService';

const Layout = ({ children }) => {
  const [open, setOpen] = useState(true);
  const [tabPage, setTabPage] = useState(1);
  const [openSubmenu, setOpenSubmenu] = useState({});
  const drawerWidth = 240;

  const location = useLocation();
  const userInfo = authService.tokenInfo();
  const hide = sessionStorage.getItem("hide");
  const name = localStorage.getItem("name");
  const navigate = useNavigate();

  const userRoles = Array.isArray(userInfo?.roles)
    ? userInfo.roles
    : userInfo?.roles
      ? [userInfo.roles]
      : [];

  const hasRole = (allowedRoles = []) =>
    allowedRoles.some(role => userRoles.includes(role));

  const menuItems = [
    {
      text: 'Home',
      icon: <Dashboard sx={{ color: '#fff' }} />,
      path: '/',
      tab: 1,
      role: ['ADMIN', 'USER', 'SUPERADMIN', 'TEACHER'],
    },
    {
      text: 'School',
      icon: <Home sx={{ color: '#fff' }} />,
      path: `/school`,
      tab: 2,
      role: ['SUPERADMIN'],
    },
    {
      text: 'Subscribe',
      icon: <Subscriptions sx={{ color: '#fff' }} />,
      path: '/subscriptionplans',
      tab: 3,
      role: ['SUPERADMIN'], //'ADMIN', 'USER', 
    },
    {
      text: 'Student',
      icon: <PersonAddAlt sx={{ color: '#fff' }} />,
      role: ['ADMIN', 'TEACHER'],
      tab: 7,
      children: [
        {
          text: 'All Students',
          path: `/student/${userInfo?.mas_code}`,
          tab: 4,
          icon: <PeopleAlt sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Class Room',
          path: '/classroom',
          tab: 5,
          icon: <PersonAddAlt sx={{ color: '#fff' }} />,
          role: ['ADMIN', 'TEACHER'],
        },
        // {
        //   text: 'Marksheet',
        //   path: '/marksheet',
        //   tab: 6,
        //   icon: <AssignmentIcon sx={{ color: '#fff' }} />,
        //   role: ['ADMIN', 'TEACHER'],
        // },
      ],
    },
    {
      text: 'Teacher',
      icon: <SchoolOutlined sx={{ color: '#fff' }} />,
      role: ['ADMIN'],
      tab: 10,
      children: [
        {
          text: 'All Teachers',
          path: '/teacher',
          tab: 8,
          icon: <PeopleAlt sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Employee Login',
          path: '/employee-login-details',
          tab: 9,
          icon: <PersonAddAlt sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Salary Settled',
          path: '/salary-slip-view',
          tab: 23,
          icon: <AccountBalanceWallet sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
      ],
    },
    {
      text: 'User Details',
      icon: <Groups sx={{ color: '#fff' }} />,
      path: '/users-details',
      tab: 11,
      role: ['SUPERADMIN'],
    },
    {
      text: 'Order Details',
      icon: <CardGiftcard sx={{ color: '#fff' }} />,
      path: '/order-details',
      tab: 12,
      role: ['SUPERADMIN'],
    },
    {
      text: 'Coupon',
      icon: <Discount sx={{ color: '#fff' }} />,
      path: '/coupon',
      tab: 13,
      role: ['SUPERADMIN'],
    },
    {
      text: 'User otp',
      path: '/user-otp',
      tab: 21,
      icon: <CalendarMonth sx={{ color: '#fff' }} />,
      role: ['SUPERADMIN'],
    },
    {
      text: 'contact us',
      path: '/contactus',
      tab: 22,
      icon: <ContactSupportSharp sx={{ color: '#fff' }} />,
      role: ['SUPERADMIN'],
    },
    {
      text: 'Tools',
      icon: <Settings sx={{ color: '#fff' }} />,
      role: ['ADMIN', 'SUPERADMIN'],
      tab: 17,
      children: [
        {
          text: 'Excel Import',
          path: '/excel',
          tab: 14,
          icon: <FileUpload sx={{ color: '#fff' }} />,
          role: ['ADMIN', 'SUPERADMIN'],
        },
        {
          text: 'Fees Structure',
          path: '/fees-structure',
          tab: 15,
          icon: <CurrencyRupee sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Holiday',
          path: '/holiday',
          tab: 16,
          icon: <CalendarMonth sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Scan QR Code',
          path: '/scanner',
          tab: 17,
          icon: <QrScannerIcon sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'PDF Converter',
          path: '/image-pdf',
          tab: 18,
          icon: <PictureAsPdf sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Offer Letter',
          path: '/offer-letter',
          tab: 19,
          icon: <Description sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        // {
        //   text: 'TC Structure',
        //   path: '/tc-structure',
        //   tab: 20,
        //   icon: <FileCopy sx={{ color: '#fff' }} />,
        //   role: ['ADMIN'],
        // },
        {
          text: 'Shift policy',
          path: '/shift-policy',
          tab: 6,
          icon: <CalendarViewDay sx={{ color: '#fff' }} />,
          role: ['ADMIN'],
        },
        {
          text: 'Sms Config',
          path: '/sms-config',
          tab: 20,
          icon: <Message sx={{ color: '#fff' }} />,
          role: ['ADMIN', 'SUPERADMIN'],
        },
      ],
    },
  ];

  const bottomMenuItems = [
    {
      text: 'My Profile',
      icon: <AccountCircle sx={{ color: '#fff' }} />,
      path: '/loginview',
      tab: 101,
    },
    {
      text: 'Logout',
      icon: <Logout sx={{ color: '#fff' }} />,
      path: '/login',
    },
  ];

  const handleLogout = (text) => {
    if (text === 'Logout') {
      authService.logout();
      navigate("/login");
    }
  };

  useEffect(() => {
    const allTabs = [
      ...menuItems.flatMap(item => item.children || [item]),
      ...bottomMenuItems,
    ];

    const matched = allTabs.find(i => i.path === location.pathname);
    if (matched?.tab) setTabPage(matched.tab);
  }, [location.pathname]);

  return (
    <Box sx={{ display: 'flex' }}>
      {hide && (
        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1300,
            // backgroundColor: "#f0f0ed",
            color: open ? "#fff" : "#f4a107",
            "&:hover": { backgroundColor: "#0b2b40", color: "#fff", }
          }}
          size="small"
        >
          {open ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
      )}

      <Drawer
        variant="persistent"
        open={open}
        sx={{
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#0b2b40',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          },
        }}
      >
        <Box>
          <Toolbar />
          <Divider />

          <List>
            {menuItems
              .filter(item => !item.role || hasRole(item.role))
              .map(item => {
                const allowedChildren = item.children?.filter(
                  child => !child.role || hasRole(child.role)
                );

                if (item.children && !allowedChildren.length) return null;

                return (
                  <React.Fragment key={item.text}>
                    <ListItemButton
                      component={item.children ? 'div' : Link}
                      to={item.children ? undefined : item.path}
                      onClick={() => {
                        if (item.children) {
                          setOpenSubmenu(prev => ({
                            ...prev,
                            [item.text]: !prev[item.text],
                          }));
                        } else {
                          setTabPage(item.tab);
                          setOpen(false);
                        }
                      }}
                      sx={{
                        backgroundColor:
                          tabPage === item.tab ||
                            (item.children && item.children.some(child => child.tab === tabPage))
                            ? 'rgba(255, 199, 1, 0.1)'
                            : 'transparent',
                        border:
                          tabPage === item.tab ||
                            (item.children && item.children.some(child => child.tab === tabPage))
                            ? '1px solid #ffc701'
                            : 'none',
                        "&:hover": { backgroundColor: 'rgba(255,199,1,0.1)' }
                      }}
                    >
                      <ListItemIcon sx={{ color: '#fff' }}>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.text} />
                      {item.children &&
                        (openSubmenu[item.text] ? <ExpandLess /> : <ExpandMore />)}
                    </ListItemButton>

                    {item.children && (
                      <Collapse in={openSubmenu[item.text]} timeout="auto">
                        <List component="div" disablePadding>
                          {allowedChildren.map(child => (
                            <ListItemButton
                              key={child.text}
                              component={Link}
                              to={child.path}
                              // sx={{ pl: 4 }}
                              onClick={() => {
                                setTabPage(child.tab);
                                setOpen(false);
                              }}
                              sx={{
                                pl: 4,
                                backgroundColor: tabPage === child.tab ? 'rgba(255,199,1,0.1)' : 'transparent',
                                borderLeft: tabPage === child.tab ? '4px solid #ffc701' : 'none',
                                "&:hover": { backgroundColor: 'rgba(255,199,1,0.2)' }
                              }}
                            >
                              <ListItemIcon sx={{ color: '#fff' }}>
                                {child.icon}
                              </ListItemIcon>
                              <ListItemText primary={child.text} />
                            </ListItemButton>
                          ))}
                        </List>
                      </Collapse>
                    )}
                  </React.Fragment>
                );
              })}
          </List>
        </Box>

        <Box>
          <Divider />

          <List>
            {bottomMenuItems.map(item => (
              <ListItemButton
                key={item.text}
                component={Link}
                to={item.path}
                onClick={() => {
                  setOpen(false);
                  handleLogout(item.text)
                  setTabPage(item.tab);
                }} sx={{
                  backgroundColor: tabPage === item.tab ? 'rgba(255,199,1,0.2)' : 'transparent',
                  border: tabPage === item.tab ? '1px solid #ffc701' : 'none',
                  // border: tabPage === item.tab ? '1px solid #ffc701' : 'none',
                  borderLeft: tabPage === item.tab ? '4px solid #ffc701' : 'none',
                  "&:hover": { backgroundColor: 'rgba(255,199,1,0.1)' }
                }}
              >
                <ListItemIcon sx={{ color: '#fff' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ))}
          </List>
        </Box>

      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: open ? `${drawerWidth}px` : 0,
          transition: 'margin-left 0.3s',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
